
import requestsActions from './actions'
import requestsGetters from './getters'
import requestsMutations from './mutations'
export default {
    namespaced: true,
    state(){
        return{
            requests: []
        }
    },
    getters: requestsGetters,
    mutations: requestsMutations,
    actions: requestsActions
}